;(function () {
    setTimeout(function () {
        if ($('.component-banner-container').length === 0) return
        var componentBanner = new Swiper('.component-banner-container', {
            direction: 'horizontal', // 垂直切换选项
            loop: $('.component-banner-container .swiper-slide').length > 1, // 循环模式选项
            observer: true,//修改swiper自己或子元素时，自动初始化swiper
            observeParents: true,//修改swiper的父元素时，自动初始化swiper

            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },

            // 如果需要分页器
            pagination: {
                el: '.component-banner-swiper-pagination',
                clickable: true
            },

            navigation: {
                nextEl: '.component-banner-container .swiper-button-next',
                prevEl: '.component-banner-container .swiper-button-prev',
            },
        });
        if (componentBanner && !common.isM) {
            //鼠标覆盖停止自动切换
            componentBanner.el.onmouseover = function(){
                componentBanner.autoplay.stop();
            }
            //鼠标离开开始自动切换
            componentBanner.el.onmouseout = function(){
                componentBanner.autoplay.start();
            }
        }
    }, 1000);
})();
